import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-center items-center gap-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Filter by", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Success ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Error ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Schedule")
const _hoisted_6 = { class: "dialog-footer" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Close")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      "destroy-on-close": "",
      title: "Detail import history",
      width: "70%",
      "close-on-click-modal": false,
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_6, [
          _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.close()))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_el_select, {
            clearable: "",
            modelValue: _ctx.params.status,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.status) = $event)),
            placeholder: "Status"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
              { label: 'Success', value: 'Success' },
              { label: 'Error', value: 'Error' },
            ], (item) => {
                return _createVNode(_component_el_option, {
                  key: item.value,
                  placeholder: "Status",
                  label: item.label,
                  value: item.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_tag, {
                      type: item.label === 'Success' ? 'success' : 'error',
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["type"])
                  ]),
                  _: 2
                }, 1032, ["label", "value"])
              }), 64))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createVNode(_component_el_row, { class: "mt-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              ref: "trackingTable",
              data: _ctx.documents,
              style: {"width":"100%"},
              isLoading: _ctx.loading,
              "header-cell-class-name": "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  property: "catalogName",
                  label: "Catalog Name",
                  "min-width": 15
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.metadata.catalogName), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  property: "productCode",
                  label: "Product Code",
                  "min-width": 15
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.metadata.productCode), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  property: "variantId",
                  label: "Variant Id",
                  "min-width": 10
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.metadata.variantId), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  property: "catalogVariantCode",
                  label: "Catalog Variant Code",
                  "min-width": 15
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.metadata.catalogVariantCode), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  property: "supcode_value",
                  label: "Supcode Value",
                  "min-width": 12
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.metadata.supcode_value), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  property: "supcode_quantity",
                  label: "Supcode Quantity",
                  "min-width": 12
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.metadata.supcode_quantity), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  property: "status",
                  label: "Status",
                  "min-width": 8,
                  align: "left"
                }, {
                  default: _withCtx((scope) => [
                    (scope.row.metadata.status === 'Success')
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 0,
                          class: "ml-2",
                          type: "success"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 1
                        }))
                      : (scope.row.metadata.status === 'Error')
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 1,
                            class: "ml-2",
                            type: "danger"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_4
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_tag, {
                            key: 2,
                            class: "ml-2",
                            type: "warning"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_5
                            ]),
                            _: 1
                          }))
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  property: "detailError",
                  label: "Detail Error",
                  "min-width": 15
                }, {
                  default: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(scope.row.metadata.detailError), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "isLoading"]),
            _createVNode(_component_pagination, {
              total: _ctx.total,
              pagination: _ctx.params.page,
              "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.page) = $event)),
              limit: _ctx.params.limit,
              "onUpdate:limit": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.limit) = $event))
            }, null, 8, ["total", "pagination", "limit"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}